<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-8">
        <h3 class="text-center">Relatório de Comissões por Loja</h3>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-10">
                <div class="row">
                  <div class="col-md-4">
                    <label>Loja:</label>
                  </div>
                  <div class="col-md-4">
                    <label for>Data Referência:</label>
                  </div>
                  <div class="col-md-4"><label for="">Gerador Por:</label></div>
                </div>

                <div class="row">
                    <div class="col-md-4">{{ !form.branch_id ? 'TODAS' : store_branch}}</div>
                    <div class="col-md-4">
                      {{ !form.reference ? 'TODAS' : date_reference }}
                    </div>
                    <div class="col-md-4">{{ user_auth_name }}</div>
                </div>

                <div class="row">
                    <div class="col-sm-12">&nbsp;</div>
                </div>

                <div class="row">
                  <div class="col-md-4">
                    <label>Administradora</label>
                  </div>
                  <div class="col-md-4">
                    <label>Período</label>
                  </div>
                  <div class="col-md-4">
                    <label>Criado em</label>

                  </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        {{ !administrator_id_ ? 'TODAS' : administrator }}
                    </div>
                    <div class="col-md-4">{{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}</div>
                    <div class="col-md-4">{{ new Date() | moment('DD/MM/YYYY') }} às {{ new Date() | moment('H[:]mm[h]')}}</div>
                </div>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="report.length">
      	<div class="col-md-12">
			<div class="panel panel-default">
				<div class="panel-body">
					<table class="table b-table table-sm">
						<thead class="thead-dark">
							<tr>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" :colspan="(getQtdCommissions(report) + 2)">Comissões</th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
							</tr>
							<tr>
								<th class="text-center">Administradora</th>
								<th class="text-center">Cotas</th>
								<th class="text-center">R$ Vendas</th>
								<th v-for="(parcela, i) in getQtdCommissions(report)" :key="i" >Parc. {{ i + 1 }}</th>
								<th class="text-center" v-if="sumExtractColumnData( 'contemplate_at', report )">R$ Contemplação</th>
								<th class="text-center" v-if="showFactureAt">R$ Faturamento</th>
								<th class="text-center">R$ Total Geral</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(iterator, key) of report" :key="key">
								<td>
									<div>
										<a href="" @click.prevent.stop="showDetailsAdministrator( iterator )"><b>{{ iterator.name }}</b></a>
										<md-tooltip style="color:red;">Clique para exibir detalhes </md-tooltip>
									</div>

								</td>
								<td class="text-center">{{ iterator.proposals.qtd_quotes }}</td>
								<td class="text-right">{{ iterator.proposals.sum_proposals | price }}</td>
								<td v-for="(parcela, i) of getDataItems(iterator.proposals.commissions)" :key="i" class="text-right">{{ parcela.parcela | price }}</td>
								<td class="text-right" v-if="iterator.proposals.contemplate_at">{{ iterator.proposals.contemplate_at | price }}</td>
								<td class="text-right" v-if="!iterator.proposals.contemplate_at && sumExtractColumnData( 'contemplate_at', report )">0,00</td>
								<td class="text-right" v-if="showFactureAt">{{ iterator.proposals.facture_at | price }}</td>
								<td class="text-right" >{{ iterator.proposals.sum | price }}</td>
							</tr>
							<tr>
								<td class="text-right" style="background-color:#ccc;"><b>Totais:</b></td>
								<td class="text-center" style="background-color:#ccc;"><b>{{ sumExtractColumnData( 'qtd_quotes', report ) }}</b></td>
								<td class="text-right"  style="background-color:#ccc;"><b>{{ sumExtractColumnData( 'sum_proposals', report ) | price }}</b></td>
								<td class="text-right" v-for="(parcela, i) in getQtdCommissions(report)" :key="i" style="background-color:#ccc;">
									<b>{{ sumCommissions( report, i) | price }}</b>
								</td>
								<td class="text-right" style="background-color:#ccc;" v-if="sumExtractColumnData( 'contemplate_at', report )"><b> {{ sumExtractColumnData( 'contemplate_at', report ) | price}} </b></td>
								<td class="text-right" style="background-color:#ccc;" v-if="showFactureAt"><b> {{ sumExtractColumnData( 'facture_at', reportDetail ) | price}} </b></td>
								<td class="text-right" style="background-color:#ccc;"><b> {{ sumExtractColumnData( 'sum', report ) | price }} </b></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

		</div>
    </div>

    <template v-else>
      <div class="row">
        <div class="col-sm-12 text-center mt-10">
            <i class="material-icons icon-image-preview">new_releases</i>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-center mb-20">
          <h2>

            Nenhum registro encontrado.

          </h2>
        </div>
      </div>
    </template>

	<div class="row" v-if="exibe_detalhamento">
		<div class="col-sm-12">
			<div class="panel panel-default">
				<div class="panel-body">
					<table class="table b-table table-sm" id="tabela">
						<thead class="thead-dark">
							<tr>
								<th class="text-center" colspan="3" style="border:1px solid #fff"> <b>{{ administrator_detail }}</b>  </th>
								<th class="text-center" :colspan="(getQtdCommissions(report) + 2)">Comissões</th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
								<th class="text-center" style="background-color:#fff; border:1px colapse"></th>
							</tr>
							<tr>
								<th class="text-center" style="">Cliente</th>
								<th class="text-center">Contrato</th>
								<th class="text-center">R$ Valor</th>
								<th v-for="(parcela, i) in getQtdCommissions(report)" :key="i" >Parc. {{ i + 1 }}</th>
								<th class="text-center" v-if="sumExtractColumnData( 'contemplate_at', reportDetail )">R$ Contemplação</th>
								<th class="text-center" v-if="showFactureAt">R$ Faturamento</th>
								<th class="text-center">R$ Total Geral</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(iterator, key) of reportDetail" :key="key">
								<td>{{ iterator.client.name }}</td>
								<td class="text-center">{{ iterator.physical_proposal }}</td>
								<td class="text-right">{{ iterator.value | price  }}</td>
								<td v-for="(parcela, i) of getDataItems(iterator.proposals.commissions)" :key="i" class="text-right">{{ parcela.parcela | price }}</td>
								<td class="text-right" v-if="iterator.proposals.contemplate_at">{{ iterator.proposals.contemplate_at | price }}</td>
								<td class="text-right" v-if="!iterator.proposals.contemplate_at && sumExtractColumnData( 'contemplate_at', reportDetail )">0,00</td>
								<td class="text-right" v-if="showFactureAt">{{
									new Intl.NumberFormat('pt-BR', { style: 'currency', currency:
									'BRL'}).format(iterator.proposals.facture_at).replace('R$', '').trim()   }}</td>
								<td class="text-right">{{ iterator.proposals.sum | price }}</td>
							</tr>
							<tr>
								<td class="text-right" style="background-color:#ccc;"><b>Totais:</b></td>
								<td class="text-center" style="background-color:#ccc;"><b>-</b></td>
								<td class="text-right"  style="background-color:#ccc;"><b>{{ sumExtractColumnData( 'value', reportDetail, true )  | price}}</b></td>
								<td class="text-right" v-for="(parcela, i) in getQtdCommissions(report)" :key="i" style="background-color:#ccc;">
									<b>{{ sumCommissions(reportDetail, i) | price }}</b>
								</td>
								<td class="text-right" style="background-color:#ccc;" v-if="sumExtractColumnData( 'contemplate_at', reportDetail )"><b>{{ sumExtractColumnData( 'contemplate_at', reportDetail ) | price}}</b></td>
								<td class="text-right" style="background-color:#ccc;"
									v-if="showFactureAt"><b>{{ sumExtractColumnData(
									'facture_at', reportDetail ) | price}}</b></td>
								<td class="text-right" style="background-color:#ccc;"><b>{{ sumExtractColumnData( 'sum', reportDetail ) | price}}</b></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <button type="button" v-if="exibe_detalhamento" @click="excel()" class="btn btn-fill btn-success">Excel</button>
      </div>
    </div>
  </div>
</template>
<script>
import DefaultService from '@/services/modules/defaults.service';
export default {
  components: {},
  computed: {
      administrators: {
          get() {
              return this.$store.state.administrators.itens;
      }
    },
	sum_commissions_details(){
      return (this.$store.state.reports.detail.length) ? this.$store.state.reports.detail[0].sum_commissions : [];
    },
    user_auth_name(){
        return this.$store.state.auth.user.name.toUpperCase();
    },
    branches() {
      return this.$store.state.defaults.branches;
    },
    report(){
        return this.$store.state.reports.item;
	},
	reportDetail(){
		return this.$store.state.reports.detail;
	}
  },
  data() {
    return {
      zeroValue: '0,00',
	  showFactureAt: false,
      administrator: null,
      store_branch: null,
      date_reference : null,
      date: null,
      end_at: null,
      form: {},
      init_at: null,
      team: null,
      sum_line:0,
      exibe_detalhamento : false,
      administrator_detail : null,
      administrator_id_ : null,
      dates : [
          { id: "sale_at", name: "Data da Venda" },
          { id: "deployment_at", name: "Data Alocação" },
          { id: "pay_at", name: "Data de Pagamento" },
          { id: "due_at", name: "Data de Vencimento (apenas parcelas pagas)" },
          { id: "due_at-all", name: "Data de Vencimento (parcelas pagas e não pagas)" }
        ]
    };
  },
  methods: {
  	showInfo(data) {
		console.log('data ', data)
		if(data === undefined) {
			data = '0,00'
		}
		return data;
	},
    excel() {
      var nome = "RELATÓRIO DE COMISSÕES POR LOJA";
      var htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
        nome +
        "</title></head><body><table>" +
        document.getElementById("tabela").innerHTML +
        "</table>";
      var htmlBase64 = btoa(htmlPlanilha);
      var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      var hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Comissões por Loja";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    },
    getDataItems(items){
      let qtd = this.getQtdCommissions(this.report);
      let totalItems = items.length;
      if(items.length < qtd){
        for(let i =0; i < Math.abs(( qtd - items.length )); i++)
          items.push({ parcela : 0});
      }

      return items;
    },
    getQtdCommissions(report){
      let count_installments = 0;

      report.forEach(element => {

        count_installments = (count_installments >= element.proposals.commissions.length) ? count_installments : element.proposals.commissions.length ;

      });

      return count_installments;
  },
	async showDetailsAdministrator(objAdministrator){

		if(this.administrator_detail == objAdministrator.name)
			this.exibe_detalhamento   = !this.exibe_detalhamento;
		else
			this.exibe_detalhamento = true;

		this.administrator_detail  = objAdministrator.name;
    this.form.administrator_id = objAdministrator.id;

    if(this.exibe_detalhamento)
    {
      var self = this;
        self.$root.$emit("onLoading");
        const response = self.$store.dispatch('reports/storeCommissionDetails', self.form);
        response.then(function (_dataReports) {
            self.$root.$emit("onLoading");
        });

        response.catch(function () {
            self.$root.$emit("onLoading");
        });
    }

	},
	sumExtractColumnData( column, commissions, vlr=false){
    let strSearch = vlr ? 'item.' : 'item.proposals.';

    if(commissions.length !== undefined){
      var elens = commissions.map(item => Number( eval(strSearch+column) ));

			return elens.reduce((total, amount) => total + amount);
		}
	},
	sumCommissions( commissions, index){
    if(commissions.length !== undefined){
			var elens = commissions.map(item => Number(item.proposals.commissions[index].parcela) );

			return elens.reduce((total, amount) => total + amount);
    }
	},
    close() {
      window.opener.focus();
      window.close();
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function(_administrators) {
        var administrator = _administrators.find(
          administrator => administrator.id === self.form.administrator_id
        );
        if (administrator !== undefined) {
          self.administrator = administrator.name;
        }
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });

      await self.getData();

    },

    async getData(){
        var self = this;

        // console.log(self.form);

        self.$root.$emit("onLoading");
        const response =  self.$store.dispatch('reports/storeCommission', self.form);

        response.then(function (_dataReports) {
			_dataReports.forEach(data => {
				if(data.proposals.facture_at) {
					self.showFactureAt = true;
				}
			});
            self.$root.$emit("onLoading");
			console.log('_dataReports ', _dataReports)
        });

        response.catch(function () {
            self.$root.$emit("onLoading");
        });
    },
    print() {
      window.print();
    }
  },
  mounted() {
    var self = this;
    self.form = JSON.parse(self.$route.query.form);
    self.store_branch   = self.form.branch_id ? self.branches.find(item => item.id === self.form.branch_id).name.toUpperCase() : null;
    self.date_reference = self.form.reference  ? self.dates.find(item => item.id === self.form.reference).name.toUpperCase()     : null;
    self.administrator_id_ = self.form.administrator_id;
    self.getDataAdministrators();

    // self.date = self.dates.find(date => date.id === self.form.date_by).name;

    self.init_at = self.form.date_at[0];

    self.end_at = self.form.date_at[1];

  }
};
</script>
<style type="scss">
@media print {
  .dont-print {
    display: none;
  }
}
</style>